export const specializations = [
  {
    id: 1,
    name: 'General Medicine',
    description: 'Comprehensive primary care and routine health checkups',
    icon: 'Stethoscope'
  },
  {
    id: 2,
    name: 'Cardiology',
    description: 'Heart health and cardiovascular disease treatment',
    icon: 'Heart'
  },
  {
    id: 3,
    name: 'Dermatology',
    description: 'Skin, hair, and nail care and treatment',
    icon: 'Sparkles'
  },
  {
    id: 4,
    name: 'Pediatrics',
    description: 'Specialized healthcare for infants and children',
    icon: 'Baby'
  },
  {
    id: 5,
    name: 'Orthopedics',
    description: 'Bone, joint, and musculoskeletal care',
    icon: 'Bone'
  },
  {
    id: 6,
    name: 'Gynecology',
    description: 'Women\'s health and reproductive care',
    icon: 'Activity'
  },
  {
    id: 7,
    name: 'Neurology',
    description: 'Brain and nervous system disorders',
    icon: 'Brain'
  },
  {
    id: 8,
    name: 'Ophthalmology',
    description: 'Eye care and vision health',
    icon: 'Eye'
  },
  {
    id: 9,
    name: 'ENT',
    description: 'Ear, nose, and throat treatment',
    icon: 'Ear'
  },
  {
    id: 10,
    name: 'Psychiatry',
    description: 'Mental health and wellness care',
    icon: 'Smile'
  },
  {
    id: 11,
    name: 'Gastroenterology',
    description: 'Digestive system and liver care',
    icon: 'Pill'
  },
  {
    id: 12,
    name: 'Urology',
    description: 'Urinary tract and kidney health',
    icon: 'Droplet'
  }
];

// Mock Doctors Data
export const doctors = [
  {
    id: 1,
    name: 'Dr. Sarah Mitchell',
    specialty: 'Cardiology',
    photo: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&q=80',
    experience: 15,
    rating: 4.9,
    reviewCount: 342,
    qualifications: 'MD, FACC, Board Certified Cardiologist',
    about: 'Dr. Mitchell specializes in interventional cardiology and has extensive experience in treating complex heart conditions. She is known for her patient-centered approach and innovative treatment methods.',
    clinicName: 'Heart Care Center',
    clinicAddress: '123 Medical Plaza, Downtown',
    distance: '2.3 km',
    consultationFee: 150,
    languages: ['English', 'Spanish'],
    gender: 'Female',
    acceptsInsurance: ['BlueCross', 'Aetna', 'United Healthcare'],
    availableSlots: [
      { date: '2025-02-01', time: '09:00 AM' },
      { date: '2025-02-01', time: '11:30 AM' },
      { date: '2025-02-02', time: '10:00 AM' },
      { date: '2025-02-03', time: '02:00 PM' }
    ],
    nextAvailable: 'Today',
    videoConsultation: true,
    featured: true,
    reviews: [
      { id: 1, patient: 'John D.', rating: 5, comment: 'Excellent doctor, very thorough and caring.', date: '2025-01-20' },
      { id: 2, patient: 'Maria S.', rating: 5, comment: 'Dr. Mitchell saved my life. Highly recommend!', date: '2025-01-15' }
    ]
  },
  {
    id: 2,
    name: 'Dr. Michael Chen',
    specialty: 'Pediatrics',
    photo: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&q=80',
    experience: 12,
    rating: 4.8,
    reviewCount: 289,
    qualifications: 'MD, FAAP, Pediatric Specialist',
    about: 'Dr. Chen is a board-certified pediatrician with a passion for child health and development. He creates a comfortable environment for children and provides comprehensive care from infancy through adolescence.',
    clinicName: 'Children\'s Health Clinic',
    clinicAddress: '456 Kids Avenue, Suburbs',
    distance: '3.5 km',
    consultationFee: 120,
    languages: ['English', 'Mandarin', 'Spanish'],
    gender: 'Male',
    acceptsInsurance: ['BlueCross', 'Cigna', 'Kaiser'],
    availableSlots: [
      { date: '2025-02-01', time: '08:00 AM' },
      { date: '2025-02-01', time: '01:00 PM' },
      { date: '2025-02-02', time: '09:30 AM' },
      { date: '2025-02-04', time: '03:00 PM' }
    ],
    nextAvailable: 'Today',
    videoConsultation: true,
    featured: true,
    reviews: [
      { id: 1, patient: 'Emily R.', rating: 5, comment: 'Great with kids! My son loves Dr. Chen.', date: '2025-01-18' },
      { id: 2, patient: 'David L.', rating: 4, comment: 'Very knowledgeable and patient.', date: '2025-01-10' }
    ]
  },
  {
    id: 3,
    name: 'Dr. Priya Sharma',
    specialty: 'Dermatology',
    photo: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&q=80',
    experience: 10,
    rating: 4.9,
    reviewCount: 412,
    qualifications: 'MD, Dermatology, Cosmetic Specialist',
    about: 'Dr. Sharma is an expert in both medical and cosmetic dermatology. She provides personalized treatment plans for various skin conditions and aesthetic concerns.',
    clinicName: 'Clear Skin Dermatology',
    clinicAddress: '789 Beauty Lane, City Center',
    distance: '1.8 km',
    consultationFee: 180,
    languages: ['English', 'Hindi', 'Punjabi'],
    gender: 'Female',
    acceptsInsurance: ['Aetna', 'United Healthcare', 'Humana'],
    availableSlots: [
      { date: '2025-02-01', time: '10:00 AM' },
      { date: '2025-02-02', time: '11:00 AM' },
      { date: '2025-02-02', time: '02:30 PM' },
      { date: '2025-02-03', time: '09:00 AM' }
    ],
    nextAvailable: 'Today',
    videoConsultation: true,
    featured: true,
    reviews: [
      { id: 1, patient: 'Lisa M.', rating: 5, comment: 'My skin has never looked better! Thank you Dr. Sharma.', date: '2025-01-22' },
      { id: 2, patient: 'Robert K.', rating: 5, comment: 'Professional and results-oriented.', date: '2025-01-16' }
    ]
  },
  {
    id: 4,
    name: 'Dr. James Wilson',
    specialty: 'Orthopedics',
    photo: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=400&q=80',
    experience: 18,
    rating: 4.7,
    reviewCount: 267,
    qualifications: 'MD, MS Orthopedics, Sports Medicine',
    about: 'Dr. Wilson specializes in sports injuries and joint replacement surgery. He has treated numerous athletes and helps patients regain mobility and strength.',
    clinicName: 'Ortho & Sports Clinic',
    clinicAddress: '321 Athletic Drive, Sports Complex',
    distance: '4.2 km',
    consultationFee: 200,
    languages: ['English'],
    gender: 'Male',
    acceptsInsurance: ['BlueCross', 'Aetna', 'Cigna', 'Medicare'],
    availableSlots: [
      { date: '2025-02-02', time: '09:00 AM' },
      { date: '2025-02-03', time: '10:30 AM' },
      { date: '2025-02-03', time: '02:00 PM' },
      { date: '2025-02-05', time: '11:00 AM' }
    ],
    nextAvailable: 'Tomorrow',
    videoConsultation: false,
    featured: false,
    reviews: [
      { id: 1, patient: 'Mike T.', rating: 5, comment: 'Got me back on the field after knee injury!', date: '2025-01-19' },
      { id: 2, patient: 'Sandra B.', rating: 4, comment: 'Very experienced surgeon.', date: '2025-01-12' }
    ]
  },
  {
    id: 5,
    name: 'Dr. Emily Rodriguez',
    specialty: 'Gynecology',
    photo: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&q=80',
    experience: 14,
    rating: 4.9,
    reviewCount: 378,
    qualifications: 'MD, OB-GYN, Women\'s Health Specialist',
    about: 'Dr. Rodriguez is dedicated to providing comprehensive women\'s healthcare with compassion and expertise. She specializes in prenatal care and gynecological surgery.',
    clinicName: 'Women\'s Wellness Center',
    clinicAddress: '567 Harmony Street, Medical District',
    distance: '2.7 km',
    consultationFee: 160,
    languages: ['English', 'Spanish'],
    gender: 'Female',
    acceptsInsurance: ['United Healthcare', 'Aetna', 'BlueCross', 'Cigna'],
    availableSlots: [
      { date: '2025-02-01', time: '01:00 PM' },
      { date: '2025-02-02', time: '10:00 AM' },
      { date: '2025-02-03', time: '03:00 PM' },
      { date: '2025-02-04', time: '11:30 AM' }
    ],
    nextAvailable: 'Today',
    videoConsultation: true,
    featured: false,
    reviews: [
      { id: 1, patient: 'Anna P.', rating: 5, comment: 'Wonderful doctor, made me feel comfortable throughout my pregnancy.', date: '2025-01-21' },
      { id: 2, patient: 'Jessica W.', rating: 5, comment: 'Highly recommend for women\'s health issues.', date: '2025-01-14' }
    ]
  },
  {
    id: 6,
    name: 'Dr. David Kim',
    specialty: 'Neurology',
    photo: 'https://images.unsplash.com/photo-1537368910025-700350fe46c7?w=400&q=80',
    experience: 16,
    rating: 4.8,
    reviewCount: 198,
    qualifications: 'MD, PhD Neurology, Epilepsy Specialist',
    about: 'Dr. Kim is a leading neurologist with expertise in treating complex neurological disorders including epilepsy, migraine, and movement disorders.',
    clinicName: 'NeuroHealth Institute',
    clinicAddress: '890 Brain Way, Research Park',
    distance: '5.1 km',
    consultationFee: 220,
    languages: ['English', 'Korean'],
    gender: 'Male',
    acceptsInsurance: ['BlueCross', 'United Healthcare', 'Medicare'],
    availableSlots: [
      { date: '2025-02-03', time: '09:00 AM' },
      { date: '2025-02-04', time: '01:00 PM' },
      { date: '2025-02-05', time: '10:30 AM' },
      { date: '2025-02-06', time: '02:00 PM' }
    ],
    nextAvailable: '3 days',
    videoConsultation: true,
    featured: false,
    reviews: [
      { id: 1, patient: 'Thomas H.', rating: 5, comment: 'Excellent neurologist, finally got proper diagnosis.', date: '2025-01-17' },
      { id: 2, patient: 'Linda G.', rating: 4, comment: 'Very thorough examination.', date: '2025-01-11' }
    ]
  },
  {
    id: 7,
    name: 'Dr. Aisha Patel',
    specialty: 'General Medicine',
    photo: 'https://images.unsplash.com/photo-1527613426441-4da17471b66d?w=400&q=80',
    experience: 8,
    rating: 4.7,
    reviewCount: 156,
    qualifications: 'MBBS, MD Internal Medicine',
    about: 'Dr. Patel provides comprehensive primary care services with a focus on preventive medicine and chronic disease management.',
    clinicName: 'Family Health Center',
    clinicAddress: '234 Wellness Road, Neighborhood',
    distance: '1.5 km',
    consultationFee: 100,
    languages: ['English', 'Hindi', 'Gujarati'],
    gender: 'Female',
    acceptsInsurance: ['Aetna', 'Cigna', 'Humana', 'Kaiser'],
    availableSlots: [
      { date: '2025-02-01', time: '08:30 AM' },
      { date: '2025-02-01', time: '03:00 PM' },
      { date: '2025-02-02', time: '09:00 AM' },
      { date: '2025-02-02', time: '01:30 PM' }
    ],
    nextAvailable: 'Today',
    videoConsultation: true,
    featured: false,
    reviews: [
      { id: 1, patient: 'Raj S.', rating: 5, comment: 'Very caring and listens to all concerns.', date: '2025-01-20' },
      { id: 2, patient: 'Karen M.', rating: 4, comment: 'Good family doctor.', date: '2025-01-13' }
    ]
  },
  {
    id: 8,
    name: 'Dr. Robert Anderson',
    specialty: 'Psychiatry',
    photo: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80',
    experience: 20,
    rating: 4.9,
    reviewCount: 423,
    qualifications: 'MD Psychiatry, Psychotherapy Certified',
    about: 'Dr. Anderson is a compassionate psychiatrist with extensive experience in treating anxiety, depression, and trauma-related disorders through both medication and therapy.',
    clinicName: 'Mental Health Wellness',
    clinicAddress: '678 Serenity Lane, Peaceful District',
    distance: '3.2 km',
    consultationFee: 190,
    languages: ['English', 'French'],
    gender: 'Male',
    acceptsInsurance: ['BlueCross', 'Aetna', 'United Healthcare', 'Cigna'],
    availableSlots: [
      { date: '2025-02-01', time: '11:00 AM' },
      { date: '2025-02-02', time: '02:00 PM' },
      { date: '2025-02-03', time: '10:00 AM' },
      { date: '2025-02-04', time: '03:30 PM' }
    ],
    nextAvailable: 'Today',
    videoConsultation: true,
    featured: true,
    reviews: [
      { id: 1, patient: 'Michelle A.', rating: 5, comment: 'Dr. Anderson changed my life. Grateful for his help.', date: '2025-01-23' },
      { id: 2, patient: 'Chris B.', rating: 5, comment: 'Excellent therapist and psychiatrist.', date: '2025-01-18' }
    ]
  },
  {
    id: 9,
    name: 'Dr. Lisa Thompson',
    specialty: 'Ophthalmology',
    photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80',
    experience: 11,
    rating: 4.8,
    reviewCount: 234,
    qualifications: 'MD Ophthalmology, LASIK Specialist',
    about: 'Dr. Thompson specializes in vision correction surgery and treatment of eye diseases. She uses the latest technology for precise diagnoses and treatments.',
    clinicName: 'Vision Care Eye Center',
    clinicAddress: '123 Clear View Street, Eye District',
    distance: '2.9 km',
    consultationFee: 170,
    languages: ['English'],
    gender: 'Female',
    acceptsInsurance: ['United Healthcare', 'Aetna', 'VSP', 'EyeMed'],
    availableSlots: [
      { date: '2025-02-02', time: '08:00 AM' },
      { date: '2025-02-02', time: '11:30 AM' },
      { date: '2025-02-03', time: '01:00 PM' },
      { date: '2025-02-04', time: '09:30 AM' }
    ],
    nextAvailable: 'Tomorrow',
    videoConsultation: false,
    featured: false,
    reviews: [
      { id: 1, patient: 'George P.', rating: 5, comment: 'LASIK surgery went perfectly. 20/20 vision now!', date: '2025-01-19' },
      { id: 2, patient: 'Nancy R.', rating: 4, comment: 'Professional and skilled.', date: '2025-01-15' }
    ]
  },
  {
    id: 10,
    name: 'Dr. Marcus Johnson',
    specialty: 'ENT',
    photo: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=400&q=80',
    experience: 13,
    rating: 4.7,
    reviewCount: 189,
    qualifications: 'MD ENT, Sinus Surgery Specialist',
    about: 'Dr. Johnson specializes in treating ear, nose, and throat conditions with both medical and surgical approaches. He is known for his expertise in sinus surgery.',
    clinicName: 'ENT Specialists Clinic',
    clinicAddress: '456 Hearing Avenue, Medical Plaza',
    distance: '3.8 km',
    consultationFee: 140,
    languages: ['English', 'Spanish'],
    gender: 'Male',
    acceptsInsurance: ['BlueCross', 'Cigna', 'Humana'],
    availableSlots: [
      { date: '2025-02-01', time: '02:00 PM' },
      { date: '2025-02-03', time: '09:30 AM' },
      { date: '2025-02-04', time: '11:00 AM' },
      { date: '2025-02-05', time: '01:30 PM' }
    ],
    nextAvailable: 'Today',
    videoConsultation: true,
    featured: false,
    reviews: [
      { id: 1, patient: 'Paul W.', rating: 5, comment: 'Fixed my chronic sinus issues. Highly recommend!', date: '2025-01-21' },
      { id: 2, patient: 'Helen C.', rating: 4, comment: 'Good doctor, helped with ear infection.', date: '2025-01-16' }
    ]
  },
  {
    id: 11,
    name: 'Dr. Samantha Lee',
    specialty: 'Gastroenterology',
    photo: 'https://images.unsplash.com/photo-1614608682850-e0d6ed316d47?w=400&q=80',
    experience: 9,
    rating: 4.8,
    reviewCount: 201,
    qualifications: 'MD Gastroenterology, IBD Specialist',
    about: 'Dr. Lee specializes in digestive health and inflammatory bowel diseases. She provides comprehensive care for various GI conditions with a patient-first approach.',
    clinicName: 'Digestive Health Center',
    clinicAddress: '789 Gut Health Lane, Wellness Park',
    distance: '4.5 km',
    consultationFee: 175,
    languages: ['English', 'Korean', 'Spanish'],
    gender: 'Female',
    acceptsInsurance: ['Aetna', 'United Healthcare', 'BlueCross'],
    availableSlots: [
      { date: '2025-02-02', time: '10:00 AM' },
      { date: '2025-02-03', time: '02:30 PM' },
      { date: '2025-02-04', time: '09:00 AM' },
      { date: '2025-02-05', time: '11:30 AM' }
    ],
    nextAvailable: 'Tomorrow',
    videoConsultation: true,
    featured: false,
    reviews: [
      { id: 1, patient: 'Brian D.', rating: 5, comment: 'Finally found relief for my IBS. Thank you Dr. Lee!', date: '2025-01-22' },
      { id: 2, patient: 'Olivia M.', rating: 4, comment: 'Very knowledgeable about digestive issues.', date: '2025-01-17' }
    ]
  },
  {
    id: 12,
    name: 'Dr. Ahmed Hassan',
    specialty: 'Urology',
    photo: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&q=80',
    experience: 17,
    rating: 4.9,
    reviewCount: 312,
    qualifications: 'MD Urology, Minimally Invasive Surgery',
    about: 'Dr. Hassan is an expert in urological conditions and minimally invasive surgical techniques. He provides comprehensive care for kidney stones, prostate issues, and urinary tract disorders.',
    clinicName: 'Advanced Urology Clinic',
    clinicAddress: '321 Kidney Road, Health Complex',
    distance: '3.6 km',
    consultationFee: 185,
    languages: ['English', 'Arabic', 'French'],
    gender: 'Male',
    acceptsInsurance: ['BlueCross', 'Aetna', 'United Healthcare', 'Medicare'],
    availableSlots: [
      { date: '2025-02-03', time: '08:30 AM' },
      { date: '2025-02-04', time: '10:00 AM' },
      { date: '2025-02-05', time: '02:00 PM' },
      { date: '2025-02-06', time: '11:00 AM' }
    ],
    nextAvailable: '3 days',
    videoConsultation: true,
    featured: true,
    reviews: [
      { id: 1, patient: 'William S.', rating: 5, comment: 'Excellent surgeon, quick recovery after procedure.', date: '2025-01-20' },
      { id: 2, patient: 'Richard T.', rating: 5, comment: 'Very professional and caring.', date: '2025-01-14' }
    ]
  }
];

export const blogPosts = [
  {
    id: 1,
    title: '10 Essential Health Tips for a Better Lifestyle',
    excerpt: 'Discover simple yet effective ways to improve your daily health routine and boost your overall wellbeing.',
    category: 'Wellness',
    date: '2025-01-15',
    readTime: '5 min read',
    image: 'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=800&q=80',
    author: 'Dr. Sarah Johnson',
    authorTitle: 'General Physician',
    content: `
      <p>Maintaining a healthy lifestyle doesn't have to be complicated. Here are ten essential health tips that can make a significant difference in your daily life.</p>
      
      <h3>1. Stay Hydrated</h3>
      <p>Drinking adequate water throughout the day is crucial for maintaining bodily functions. Aim for at least 8 glasses of water daily to keep your body hydrated and functioning optimally.</p>
      
      <h3>2. Get Regular Exercise</h3>
      <p>Physical activity is essential for maintaining a healthy weight, improving cardiovascular health, and boosting mental wellbeing. Aim for at least 30 minutes of moderate exercise most days of the week.</p>
      
      <h3>3. Prioritize Sleep</h3>
      <p>Quality sleep is fundamental to good health. Adults should aim for 7-9 hours of sleep per night. Establish a consistent sleep schedule and create a relaxing bedtime routine.</p>
      
      <h3>4. Eat a Balanced Diet</h3>
      <p>Focus on whole foods, including fruits, vegetables, lean proteins, and whole grains. Limit processed foods and excessive sugar intake.</p>
      
      <h3>5. Manage Stress</h3>
      <p>Chronic stress can negatively impact your health. Practice stress-management techniques such as meditation, deep breathing, or yoga.</p>
      
      <h3>6. Regular Health Checkups</h3>
      <p>Don't wait until you're sick to see a doctor. Regular checkups can help detect potential health issues early when they're most treatable.</p>
      
      <h3>7. Practice Good Hygiene</h3>
      <p>Wash your hands regularly, maintain dental hygiene, and practice good personal hygiene to prevent infections and diseases.</p>
      
      <h3>8. Limit Alcohol and Avoid Smoking</h3>
      <p>Both alcohol and smoking have significant negative health impacts. If you drink, do so in moderation, and seek help to quit smoking if needed.</p>
      
      <h3>9. Stay Connected</h3>
      <p>Social connections are important for mental health. Maintain relationships with family and friends, and don't hesitate to seek support when needed.</p>
      
      <h3>10. Listen to Your Body</h3>
      <p>Pay attention to what your body is telling you. If something doesn't feel right, don't ignore it. Seek medical advice when necessary.</p>
      
      <p>Remember, small changes can lead to significant improvements in your overall health and wellbeing. Start implementing these tips today for a healthier tomorrow.</p>
    `
  },
  {
    id: 2,
    title: 'Understanding Heart Health: Prevention and Care',
    excerpt: 'Learn about cardiovascular health, warning signs, and preventive measures to keep your heart healthy.',
    category: 'Cardiology',
    date: '2025-01-12',
    readTime: '7 min read',
    image: 'https://images.unsplash.com/photo-1628348070889-cb656235b4eb?w=800&q=80',
    author: 'Dr. Michael Chen',
    authorTitle: 'Cardiologist',
    content: `
      <p>Heart disease remains one of the leading causes of death worldwide. Understanding how to maintain heart health is crucial for a long and healthy life.</p>
      
      <h3>Understanding Your Heart</h3>
      <p>The heart is a powerful muscle that pumps blood throughout your body, delivering oxygen and nutrients to your tissues. Maintaining its health is essential for overall wellbeing.</p>
      
      <h3>Risk Factors for Heart Disease</h3>
      <p>Several factors can increase your risk of heart disease:</p>
      <ul>
        <li>High blood pressure</li>
        <li>High cholesterol</li>
        <li>Smoking</li>
        <li>Diabetes</li>
        <li>Obesity</li>
        <li>Family history</li>
        <li>Sedentary lifestyle</li>
      </ul>
      
      <h3>Warning Signs</h3>
      <p>Know the warning signs of heart problems:</p>
      <ul>
        <li>Chest pain or discomfort</li>
        <li>Shortness of breath</li>
        <li>Pain in arms, back, neck, or jaw</li>
        <li>Irregular heartbeat</li>
        <li>Fatigue</li>
        <li>Dizziness or lightheadedness</li>
      </ul>
      
      <h3>Prevention Strategies</h3>
      <p>You can take several steps to protect your heart health:</p>
      
      <h4>Diet</h4>
      <p>Follow a heart-healthy diet rich in fruits, vegetables, whole grains, and lean proteins. Limit saturated fats, trans fats, and sodium.</p>
      
      <h4>Exercise</h4>
      <p>Regular physical activity strengthens your heart and improves circulation. Aim for at least 150 minutes of moderate aerobic activity per week.</p>
      
      <h4>Manage Stress</h4>
      <p>Chronic stress can contribute to heart disease. Find healthy ways to manage stress through relaxation techniques, hobbies, or counseling.</p>
      
      <h4>Regular Checkups</h4>
      <p>Schedule regular checkups with your healthcare provider to monitor blood pressure, cholesterol levels, and overall heart health.</p>
      
      <p>Taking care of your heart is a lifelong commitment. Start making heart-healthy choices today for a healthier tomorrow.</p>
    `
  },
  {
    id: 3,
    title: 'Mental Health Matters: Breaking the Stigma',
    excerpt: 'Explore the importance of mental health awareness and how to support yourself and loved ones.',
    category: 'Mental Health',
    date: '2025-01-10',
    readTime: '6 min read',
    image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=800&q=80',
    author: 'Dr. Emily Rodriguez',
    authorTitle: 'Psychiatrist',
    content: `
      <p>Mental health is just as important as physical health, yet it often carries an unfortunate stigma. It's time to break down these barriers and prioritize mental wellbeing.</p>
      
      <h3>Understanding Mental Health</h3>
      <p>Mental health encompasses our emotional, psychological, and social wellbeing. It affects how we think, feel, and act in daily life.</p>
      
      <h3>Common Mental Health Conditions</h3>
      <p>Mental health conditions are common and treatable:</p>
      <ul>
        <li>Depression</li>
        <li>Anxiety disorders</li>
        <li>Bipolar disorder</li>
        <li>Post-traumatic stress disorder (PTSD)</li>
        <li>Obsessive-compulsive disorder (OCD)</li>
      </ul>
      
      <h3>Breaking the Stigma</h3>
      <p>Stigma around mental health prevents many people from seeking help. We can combat this by:</p>
      <ul>
        <li>Talking openly about mental health</li>
        <li>Educating ourselves and others</li>
        <li>Using respectful language</li>
        <li>Supporting those who are struggling</li>
        <li>Advocating for better mental health resources</li>
      </ul>
      
      <h3>Self-Care Strategies</h3>
      <p>Taking care of your mental health is essential:</p>
      
      <h4>Practice Mindfulness</h4>
      <p>Meditation and mindfulness can help reduce stress and improve emotional regulation.</p>
      
      <h4>Stay Connected</h4>
      <p>Maintain relationships with friends and family. Social support is crucial for mental wellbeing.</p>
      
      <h4>Exercise Regularly</h4>
      <p>Physical activity has been shown to improve mood and reduce symptoms of depression and anxiety.</p>
      
      <h4>Get Professional Help</h4>
      <p>Don't hesitate to seek professional help if you're struggling. Therapy and counseling can be incredibly beneficial.</p>
      
      <h3>Supporting Others</h3>
      <p>If someone you know is struggling with mental health:</p>
      <ul>
        <li>Listen without judgment</li>
        <li>Offer support and encouragement</li>
        <li>Help them find professional resources</li>
        <li>Check in regularly</li>
        <li>Educate yourself about their condition</li>
      </ul>
      
      <p>Remember, seeking help for mental health is a sign of strength, not weakness. Together, we can create a more supportive and understanding society.</p>
    `
  },
  {
    id: 4,
    title: 'Nutrition Guide: Eating Right for Your Health',
    excerpt: 'A comprehensive guide to balanced nutrition and making healthier food choices for optimal health.',
    category: 'Nutrition',
    date: '2025-01-08',
    readTime: '8 min read',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&q=80',
    author: 'Dr. Lisa Anderson',
    authorTitle: 'Nutritionist',
    content: `
      <p>Good nutrition is the foundation of good health. Understanding how to make healthy food choices can significantly impact your overall wellbeing.</p>
      
      <h3>The Basics of Nutrition</h3>
      <p>Your body needs a variety of nutrients to function properly:</p>
      <ul>
        <li>Proteins for tissue repair and growth</li>
        <li>Carbohydrates for energy</li>
        <li>Fats for hormone production and nutrient absorption</li>
        <li>Vitamins and minerals for various bodily functions</li>
        <li>Water for hydration and cellular processes</li>
      </ul>
      
      <h3>Building a Balanced Plate</h3>
      <p>A balanced meal should include:</p>
      <ul>
        <li>Half your plate: vegetables and fruits</li>
        <li>Quarter of your plate: lean proteins</li>
        <li>Quarter of your plate: whole grains</li>
        <li>Small amount of healthy fats</li>
      </ul>
      
      <h3>Nutrient-Dense Foods</h3>
      <p>Focus on foods that provide maximum nutrition:</p>
      
      <h4>Fruits and Vegetables</h4>
      <p>Rich in vitamins, minerals, and antioxidants. Aim for a variety of colors to ensure diverse nutrient intake.</p>
      
      <h4>Whole Grains</h4>
      <p>Choose whole grains over refined grains for more fiber and nutrients.</p>
      
      <h4>Lean Proteins</h4>
      <p>Include fish, poultry, beans, legumes, and nuts in your diet.</p>
      
      <h4>Healthy Fats</h4>
      <p>Incorporate sources of omega-3 fatty acids like fish, nuts, and olive oil.</p>
      
      <h3>Foods to Limit</h3>
      <p>Reduce intake of:</p>
      <ul>
        <li>Processed foods high in sodium</li>
        <li>Added sugars and sweetened beverages</li>
        <li>Saturated and trans fats</li>
        <li>Excessive red meat</li>
      </ul>
      
      <h3>Practical Tips</h3>
      <p>Making healthy eating sustainable:</p>
      <ul>
        <li>Plan your meals in advance</li>
        <li>Prepare healthy snacks</li>
        <li>Read nutrition labels</li>
        <li>Cook at home more often</li>
        <li>Practice portion control</li>
        <li>Stay hydrated</li>
      </ul>
      
      <h3>Special Considerations</h3>
      <p>Individual nutritional needs vary based on age, activity level, health conditions, and other factors. Consult with a healthcare provider or registered dietitian for personalized advice.</p>
      
      <p>Remember, healthy eating is about progress, not perfection. Small, consistent changes can lead to lasting improvements in your health.</p>
    `
  },
  {
    id: 5,
    title: 'The Importance of Regular Health Screenings',
    excerpt: 'Learn why preventive health screenings are crucial for early detection and treatment of diseases.',
    category: 'Preventive Care',
    date: '2025-01-05',
    readTime: '6 min read',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    author: 'Dr. Robert Williams',
    authorTitle: 'Internal Medicine',
    content: `
      <p>Regular health screenings are one of the most important steps you can take to maintain your health. Early detection often leads to better treatment outcomes.</p>
      
      <h3>Why Screenings Matter</h3>
      <p>Health screenings can detect diseases in their early stages, often before symptoms appear. This early detection can:</p>
      <ul>
        <li>Increase treatment success rates</li>
        <li>Reduce healthcare costs</li>
        <li>Improve quality of life</li>
        <li>Prevent disease progression</li>
      </ul>
      
      <h3>Essential Screenings by Age</h3>
      
      <h4>Adults 18-39</h4>
      <ul>
        <li>Blood pressure check (every 2 years)</li>
        <li>Cholesterol screening (every 5 years)</li>
        <li>Diabetes screening (if at risk)</li>
        <li>Dental checkups (twice yearly)</li>
        <li>Eye exams (every 2 years)</li>
      </ul>
      
      <h4>Adults 40-64</h4>
      <ul>
        <li>All screenings above, plus:</li>
        <li>Mammography (women, annually or as recommended)</li>
        <li>Colorectal cancer screening (starting at 45)</li>
        <li>Prostate cancer screening (men, discuss with doctor)</li>
        <li>Bone density scan (women at risk)</li>
      </ul>
      
      <h4>Adults 65+</h4>
      <ul>
        <li>All previous screenings, plus:</li>
        <li>Annual wellness visits</li>
        <li>Hearing tests</li>
        <li>Falls risk assessment</li>
        <li>Cognitive screening</li>
      </ul>
      
      <h3>Don't Skip Your Checkups</h3>
      <p>Many people avoid health screenings due to fear, busy schedules, or cost concerns. However, the benefits far outweigh these obstacles.</p>
      
      <p>Take control of your health today by scheduling your recommended screenings. Prevention is always better than treatment.</p>
    `
  },
  {
    id: 6,
    title: 'Managing Chronic Pain: A Comprehensive Approach',
    excerpt: 'Effective strategies for living with and managing chronic pain conditions.',
    category: 'Pain Management',
    date: '2025-01-03',
    readTime: '7 min read',
    image: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800&q=80',
    author: 'Dr. Jennifer Martinez',
    authorTitle: 'Pain Management Specialist',
    content: `
      <p>Chronic pain affects millions of people worldwide. Understanding how to manage it effectively can significantly improve quality of life.</p>
      
      <h3>Understanding Chronic Pain</h3>
      <p>Chronic pain is pain that persists for more than three months, often beyond the expected healing time. It can result from various conditions including arthritis, nerve damage, or past injuries.</p>
      
      <h3>Multidisciplinary Approach</h3>
      <p>Effective chronic pain management often requires a combination of treatments:</p>
      
      <h4>Medical Treatments</h4>
      <ul>
        <li>Medications (as prescribed)</li>
        <li>Physical therapy</li>
        <li>Interventional procedures</li>
        <li>Alternative therapies (acupuncture, massage)</li>
      </ul>
      
      <h4>Lifestyle Modifications</h4>
      <ul>
        <li>Regular exercise adapted to your abilities</li>
        <li>Healthy diet</li>
        <li>Adequate sleep</li>
        <li>Stress management</li>
      </ul>
      
      <h4>Psychological Support</h4>
      <ul>
        <li>Cognitive behavioral therapy</li>
        <li>Relaxation techniques</li>
        <li>Support groups</li>
        <li>Mindfulness meditation</li>
      </ul>
      
      <h3>Self-Management Strategies</h3>
      <p>You can take an active role in managing your pain:</p>
      <ul>
        <li>Keep a pain diary to identify triggers</li>
        <li>Pace yourself and avoid overexertion</li>
        <li>Practice good posture</li>
        <li>Use heat or cold therapy as appropriate</li>
        <li>Stay socially connected</li>
      </ul>
      
      <p>Remember, chronic pain management is a journey. Work closely with your healthcare team to find the right combination of treatments for you.</p>
    `
  },
  {
    id: 7,
    title: 'Boosting Your Immune System Naturally',
    excerpt: 'Science-backed strategies to strengthen your immune system and fight off infections.',
    category: 'Wellness',
    date: '2025-01-18',
    readTime: '6 min read',
    image: 'https://images.unsplash.com/photo-1505576399279-565b52d4ac71?w=800&q=80',
    author: 'Dr. Sarah Johnson',
    authorTitle: 'General Physician',
    content: `
      <p>A strong immune system is your body's first line of defense against illness. Here are proven ways to boost your immunity naturally.</p>
      
      <h3>Understanding Your Immune System</h3>
      <p>The immune system is a complex network of cells, tissues, and organs that work together to defend your body against harmful pathogens.</p>
      
      <h3>Natural Immune Boosters</h3>
      <p>Support your immune system with these strategies:</p>
      <ul>
        <li>Get adequate sleep (7-9 hours nightly)</li>
        <li>Exercise regularly but not excessively</li>
        <li>Eat a rainbow of fruits and vegetables</li>
        <li>Stay hydrated throughout the day</li>
        <li>Manage stress through relaxation techniques</li>
        <li>Limit alcohol consumption</li>
        <li>Don't smoke</li>
      </ul>
      
      <h3>Immune-Supporting Nutrients</h3>
      <p>Key nutrients for immune health include vitamin C, vitamin D, zinc, and probiotics. Focus on whole foods rather than supplements when possible.</p>
      
      <p>Remember, there's no magic pill for immunity. Consistency with healthy habits is key to maintaining a robust immune system.</p>
    `
  },
  {
    id: 8,
    title: 'Understanding Diabetes: Prevention and Management',
    excerpt: 'Essential information about diabetes types, risk factors, and effective management strategies.',
    category: 'Chronic Conditions',
    date: '2025-01-16',
    readTime: '8 min read',
    image: 'https://images.unsplash.com/photo-1583324113626-70df0f4deaab?w=800&q=80',
    author: 'Dr. Priya Sharma',
    authorTitle: 'Endocrinologist',
    content: `
      <p>Diabetes is a chronic condition affecting millions worldwide. Understanding it is the first step toward prevention and effective management.</p>
      
      <h3>Types of Diabetes</h3>
      <p>There are three main types: Type 1, Type 2, and gestational diabetes. Each requires different management approaches.</p>
      
      <h3>Risk Factors</h3>
      <ul>
        <li>Family history of diabetes</li>
        <li>Being overweight or obese</li>
        <li>Sedentary lifestyle</li>
        <li>Age over 45</li>
        <li>High blood pressure</li>
        <li>Abnormal cholesterol levels</li>
      </ul>
      
      <h3>Prevention Strategies</h3>
      <p>For Type 2 diabetes, lifestyle changes can significantly reduce your risk:</p>
      <ul>
        <li>Maintain a healthy weight</li>
        <li>Exercise regularly (150 minutes per week)</li>
        <li>Follow a balanced diet</li>
        <li>Limit refined carbohydrates and sugars</li>
        <li>Don't smoke</li>
      </ul>
      
      <h3>Management Tips</h3>
      <p>If diagnosed with diabetes, effective management includes monitoring blood sugar, taking medications as prescribed, eating healthily, exercising, and regular checkups with your healthcare team.</p>
    `
  },
  {
    id: 9,
    title: 'Sleep Better: A Guide to Improving Sleep Quality',
    excerpt: 'Discover evidence-based techniques to improve your sleep quality and wake up refreshed.',
    category: 'Wellness',
    date: '2025-01-14',
    readTime: '7 min read',
    image: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=800&q=80',
    author: 'Dr. Sarah Johnson',
    authorTitle: 'General Physician',
    content: `
      <p>Quality sleep is essential for physical and mental health. Learn how to optimize your sleep for better overall wellbeing.</p>
      
      <h3>Why Sleep Matters</h3>
      <p>During sleep, your body repairs tissues, consolidates memories, and regulates hormones. Poor sleep affects every aspect of health.</p>
      
      <h3>Sleep Hygiene Essentials</h3>
      <ul>
        <li>Keep a consistent sleep schedule</li>
        <li>Create a dark, cool, quiet bedroom</li>
        <li>Avoid screens 1 hour before bed</li>
        <li>Limit caffeine after 2 PM</li>
        <li>Exercise regularly, but not close to bedtime</li>
        <li>Avoid large meals late at night</li>
      </ul>
      
      <h3>Creating a Bedtime Routine</h3>
      <p>Develop a relaxing pre-sleep routine: dim lights, read a book, practice gentle stretches, or try meditation. Consistency signals your body it's time to sleep.</p>
      
      <h3>When to Seek Help</h3>
      <p>If sleep problems persist despite good sleep hygiene, consult a healthcare provider. You may have a sleep disorder requiring professional treatment.</p>
    `
  },
  {
    id: 10,
    title: 'Women\'s Health: Essential Screenings and Checkups',
    excerpt: 'A comprehensive guide to important health screenings every woman should know about.',
    category: 'Women\'s Health',
    date: '2025-01-13',
    readTime: '6 min read',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&q=80',
    author: 'Dr. Amanda Foster',
    authorTitle: 'Obstetrician & Gynecologist',
    content: `
      <p>Women have unique health needs that change throughout life. Regular screenings and checkups are vital for early detection and prevention.</p>
      
      <h3>Essential Screenings by Age</h3>
      
      <h4>Ages 20-39</h4>
      <ul>
        <li>Pap smear (every 3 years starting at 21)</li>
        <li>Breast self-exam (monthly)</li>
        <li>STI screening (if sexually active)</li>
        <li>Thyroid screening (if symptoms present)</li>
      </ul>
      
      <h4>Ages 40-64</h4>
      <ul>
        <li>Mammogram (annually or as recommended)</li>
        <li>Pap smear and HPV test (every 5 years)</li>
        <li>Bone density scan (if at risk)</li>
        <li>Colorectal cancer screening (starting at 45)</li>
      </ul>
      
      <h4>Ages 65+</h4>
      <ul>
        <li>Continue regular mammograms</li>
        <li>Annual wellness visits</li>
        <li>Bone density screening</li>
        <li>Cardiovascular assessments</li>
      </ul>
      
      <h3>Taking Charge of Your Health</h3>
      <p>Don't wait for symptoms to appear. Schedule regular checkups and screenings. Prevention and early detection save lives.</p>
    `
  },
  {
    id: 11,
    title: 'Exercise for Heart Health: Getting Started Safely',
    excerpt: 'Learn how to begin an exercise program that strengthens your cardiovascular system.',
    category: 'Cardiology',
    date: '2025-01-11',
    readTime: '6 min read',
    image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&q=80',
    author: 'Dr. Michael Chen',
    authorTitle: 'Cardiologist',
    content: `
      <p>Regular exercise is one of the best things you can do for your heart. Learn how to start safely and build a sustainable routine.</p>
      
      <h3>Benefits of Exercise for Your Heart</h3>
      <ul>
        <li>Lowers blood pressure</li>
        <li>Improves cholesterol levels</li>
        <li>Helps maintain healthy weight</li>
        <li>Reduces stress</li>
        <li>Strengthens heart muscle</li>
        <li>Improves circulation</li>
      </ul>
      
      <h3>Types of Heart-Healthy Exercise</h3>
      
      <h4>Aerobic Exercise</h4>
      <p>Activities like walking, jogging, swimming, and cycling. Aim for 150 minutes of moderate-intensity aerobic activity weekly.</p>
      
      <h4>Strength Training</h4>
      <p>Build muscle with resistance exercises 2-3 times per week. This helps manage weight and improves metabolism.</p>
      
      <h4>Flexibility and Balance</h4>
      <p>Incorporate stretching and balance exercises to prevent injuries and maintain mobility.</p>
      
      <h3>Getting Started Safely</h3>
      <p>If you have heart disease or risk factors, consult your doctor before starting an exercise program. Start slowly and gradually increase intensity and duration.</p>
      
      <h3>Warning Signs to Stop</h3>
      <p>Stop exercising and seek medical attention if you experience chest pain, severe shortness of breath, dizziness, or irregular heartbeat.</p>
    `
  },
  {
    id: 12,
    title: 'Childhood Nutrition: Building Healthy Eating Habits',
    excerpt: 'Essential nutritional guidelines for raising healthy, active children.',
    category: 'Nutrition',
    date: '2025-01-09',
    readTime: '7 min read',
    image: 'https://images.unsplash.com/photo-1609220136736-443140cffec6?w=800&q=80',
    author: 'Dr. Lisa Anderson',
    authorTitle: 'Nutritionist',
    content: `
      <p>Establishing healthy eating habits in childhood sets the foundation for lifelong wellness. Here's how to nurture good nutrition in your children.</p>
      
      <h3>Nutritional Needs by Age</h3>
      <p>Children's nutritional needs change as they grow. Ensure adequate intake of proteins, healthy fats, complex carbohydrates, vitamins, and minerals.</p>
      
      <h3>Creating a Positive Food Environment</h3>
      <ul>
        <li>Offer a variety of healthy foods</li>
        <li>Involve children in meal planning and preparation</li>
        <li>Make mealtimes enjoyable and stress-free</li>
        <li>Avoid using food as reward or punishment</li>
        <li>Be a positive role model</li>
      </ul>
      
      <h3>Dealing with Picky Eaters</h3>
      <p>It's normal for children to be selective. Continue offering varied foods without pressure. It may take 10-15 exposures before a child accepts a new food.</p>
      
      <h3>Healthy Snack Ideas</h3>
      <ul>
        <li>Fresh fruits and vegetables with dips</li>
        <li>Whole grain crackers with cheese</li>
        <li>Yogurt with berries</li>
        <li>Nuts and seeds (for older children)</li>
        <li>Homemade smoothies</li>
      </ul>
      
      <h3>Limiting Unhealthy Foods</h3>
      <p>Reduce sugary drinks, processed snacks, and fast food. Teach children to recognize hunger and fullness cues rather than emotional eating.</p>
    `
  }
];

export const appFeatures = [
  {
    id: 1,
    title: 'Video Consultations',
    description: 'Connect with doctors via secure video calls',
    icon: 'Video'
  },
  {
    id: 2,
    title: 'Appointment Booking',
    description: 'Schedule appointments easily at your convenience',
    icon: 'Calendar'
  },
  {
    id: 3,
    title: 'Digital Prescriptions',
    description: 'Receive and store prescriptions digitally',
    icon: 'FileText'
  },
  {
    id: 4,
    title: 'Health Records',
    description: 'Access your medical history anytime, anywhere',
    icon: 'FolderOpen'
  }
];